import mitt from 'mitt'

export interface ApiErrorEvent {
  message: string
  title?: string
  type?: 'error' | 'warning' | 'info' | 'success'
}

type ApiEvents = {
  error: ApiErrorEvent
}

export const apiEvents = mitt<ApiEvents>()
